import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/factorial-calculator',
  component: () => import('../../routes/FactorialCalculator.svelte'),
  card: {
    id: 'factorial-calculator',
    title: 'Factorial Calculator',
    description: 'Calculate the factorial of any non-negative integer with step-by-step breakdown.',
    icon: 'calculate',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/factorial-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Factorial Calculator – Free n! Calculator with Step-by-Step Breakdown',
    description: 'Free factorial calculator. Compute n! for any non-negative integer with step-by-step breakdown, digit count, and natural log. Perfect for permutations, combinations, and probability calculations.',
  },
};

export default meta;
